export enum Features {
    CANDIDATE = 'candidateFeature',
    EMPLOYEE = 'employeeFeature',
    PARTNER = 'partnerFeature',
    CANDIBANK = 'hierTalentCandiBank',
    WELLNESS = 'hierTalentWellnessScreening',
}

export enum FeatureNames {
    CANDIDATE = 'Candidate',
    EMPLOYEE = 'Employee',
    PARTNER = 'Partner',
}

/** Whether a tenant's subscription has `feature` active or trialing. Only the
 * three gated features (employee/candidate/partner) are enforced; any other
 * feature is treated as available, matching the route gate's prior default. */
const GATED_FEATURES: ReadonlySet<string> = new Set([
  Features.EMPLOYEE,
  Features.CANDIDATE,
  Features.PARTNER,
]);

// Accepts the SubscriptionDetails object as stored in Redux (typed with named
// feature fields) as well as any plain map of feature -> { status }.
export function hasActiveFeature(
  subscriptionData: object | null | undefined,
  feature: string,
): boolean {
  if (!GATED_FEATURES.has(feature)) return true;
  const entries = subscriptionData as Record<string, { status?: string } | undefined> | null | undefined;
  const status = entries?.[feature]?.status;
  return status === 'active' || status === 'trialing';
}
